import { dataLayout } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLayout = /*#__PURE__*/createIcon(dataLayout)
export default IconLayout
